var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcHomeSalir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#87d7d6;stroke:#87d7d6;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30,50.47A19.49,19.49,0,0,1,10.44,31.1a19.19,19.19,0,0,1,7.5-15.26,1.36,1.36,0,0,1,1.89.23,1.32,1.32,0,0,1-.23,1.87A16.57,16.57,0,0,0,13.14,31.1a16.86,16.86,0,0,0,33.72,0A16.53,16.53,0,0,0,40.42,18a1.34,1.34,0,1,1,1.67-2.1A19.19,19.19,0,0,1,49.56,31.1,19.49,19.49,0,0,1,30,50.47Zm1.35-22.15V10.87a1.35,1.35,0,0,0-2.7,0V28.32a1.35,1.35,0,0,0,2.7,0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcHomeSalir);
export default __webpack_public_path__ + "static/media/DC_Home_salir.4fdb189a28fc12e4af2cbbf9d991dbe3.svg";
export { ForwardRef as ReactComponent };